exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".settingsDiv {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n.dashboardButton {\n  cursor: pointer;\n}\n.changeSettingsButtons {\n  margin: 0 0 0 0;\n}\n.errorMessage {\n  color: red;\n}\n.emailVerificationDiv {\n  margin-top: 5px;\n}\n.logoutButton {\n  float: right;\n  margin-top: 17px;\n}\n.newEmail {\n  margin-bottom: 5px;\n}\n.newPassword {\n  margin-bottom: 5px;\n}\n.error-message {\n  color: red;\n  text-align: center;\n}\n.edit-delete-container i {\n  margin: 0.3em 0.4em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/less-loader/dist/cjs.js??ref--5-3!./src/styles/settings.less
// module id = 1228
// module chunks = 0